import { render, staticRenderFns } from "./ProposalActionButtons.vue?vue&type=template&id=09e84dc0"
import script from "./ProposalActionButtons.vue?vue&type=script&lang=js"
export * from "./ProposalActionButtons.vue?vue&type=script&lang=js"
import style0 from "./ProposalActionButtons.vue?vue&type=style&index=0&id=09e84dc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports